export default function clearRegion() {
  const url = new URL(window.location.href);
  url.searchParams.delete('region');

  window.location.replace(url);
}
